"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditProject;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _queryString = _interopRequireDefault(require("query-string"));

var _VideoList = _interopRequireDefault(require("../../../common/components/VideoList"));

var _VideoSummaryCard = _interopRequireDefault(require("../../../common/components/VideoSummaryCard"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function fetchProject(_x) {
  return _fetchProject.apply(this, arguments);
}

function _fetchProject() {
  _fetchProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var getVideoProject, getProjectStats, getVideoFolder, projectId, setState, _yield$Promise$all, _yield$Promise$all2, _yield$Promise$all2$, data, error, _yield$Promise$all2$2, statsData, statsError, _yield$getVideoFolder, folderData, folderError;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getVideoProject = _ref.getVideoProject, getProjectStats = _ref.getProjectStats, getVideoFolder = _ref.getVideoFolder, projectId = _ref.projectId, setState = _ref.setState;
            _context.next = 3;
            return Promise.all([getVideoProject(projectId), getProjectStats()]);

          case 3:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            _yield$Promise$all2$ = _yield$Promise$all2[0];
            data = _yield$Promise$all2$.data;
            error = _yield$Promise$all2$.error;
            _yield$Promise$all2$2 = _yield$Promise$all2[1];
            statsData = _yield$Promise$all2$2.data;
            statsError = _yield$Promise$all2$2.error;

            if (!(!data || !data.getVideoProject || error || !statsData || !statsData.getProjectStats || statsError)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", void setState({
              error: true
            }));

          case 13:
            if (data.getVideoProject.videoFolderId) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", void setState({
              project: data.getVideoProject,
              stats: statsData.getProjectStats
            }));

          case 15:
            _context.next = 17;
            return getVideoFolder(data.getVideoProject.videoFolderId);

          case 17:
            _yield$getVideoFolder = _context.sent;
            folderData = _yield$getVideoFolder.data;
            folderError = _yield$getVideoFolder.error;

            if (!(!folderData || !folderData.getVideoFolder || folderError)) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", void setState({
              error: true
            }));

          case 22:
            setState({
              project: data.getVideoProject,
              stats: statsData.getProjectStats,
              folder: folderData.getVideoFolder
            });

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchProject.apply(this, arguments);
}

function EditProject(_ref2) {
  var projectId = _ref2.projectId,
      getVideoProject = _ref2.getVideoProject,
      getProjectStats = _ref2.getProjectStats,
      location = _ref2.location,
      containerSize = _ref2.containerSize,
      getVideoFolder = _ref2.getVideoFolder;

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      project = _useState2$.project,
      stats = _useState2$.stats,
      folder = _useState2$.folder,
      error = _useState2$.error,
      setState = _useState2[1];

  (0, _react.useEffect)(function () {
    if (project || error) {
      return;
    }

    fetchProject({
      getVideoProject: getVideoProject,
      getProjectStats: getProjectStats,
      getVideoFolder: getVideoFolder,
      projectId: projectId,
      setState: setState
    });
  }, [project, projectId]);

  if (error) {
    return /*#__PURE__*/_react.default.createElement(_commonReact.Error, null);
  }

  var queryParams = _queryString.default.parse(location.search.substr(1), {
    arrayFormat: 'comma'
  });

  var statsKey = queryParams.USER && queryParams.USER === 'ALL' ? 'global' : 'user';
  var outputCount = (0, _lodash.default)(stats, "".concat(statsKey, ".outputs"), 0);
  var assetCount = (0, _lodash.default)(stats, "".concat(statsKey, ".assets"), 0);
  var isSmall = containerSize.width < _vars.NUMERIC_MEDIA_SIZES.medium;
  return /*#__PURE__*/_react.default.createElement(_VideoList.default, {
    summaryTitle: "Manage and sort your Videos",
    videoProjectId: projectId,
    headerSubtitle: "Video Dashboard",
    headerSubtitleLink: "/",
    headerTitle: // If no project or no project folder, display the project name,
    // otherwise wait for the folder name before displaying the project name
    project && (project.videoFolderId ? folder && folder.name && project.name : project.name),
    headerBreadcrumbs: [{
      title: 'Manage Projects',
      url: '/projects'
    }, folder ? {
      title: folder.name,
      url: "/folder/".concat(folder.videoFolderId)
    } : void 0].filter(Boolean),
    summaryCards: [/*#__PURE__*/_react.default.createElement(_VideoSummaryCard.default, {
      key: "output",
      label: "VIDEO".concat(!outputCount || outputCount > 1 ? 'S' : ''),
      count: outputCount,
      status: "EDITING",
      small: isSmall
    }), /*#__PURE__*/_react.default.createElement(_VideoSummaryCard.default, {
      key: "assets",
      label: "ASSET".concat(!assetCount || assetCount > 1 ? 'S' : ''),
      count: assetCount,
      status: "EDITING",
      small: isSmall
    })]
  });
}